export default __webpack_public_path__ + "static/media/gulaba.848baadb.jpg";